<p-dialog [(visible)]="visible" [style]="{ width: '600px' }" header="Configuración de Correos" [modal]="true"
    [draggable]="false">

    <ng-template #content>
        <div [formGroup]="form" class="flex flex-col gap-6 py-4">

            @if (isLoading()) {
            <div class="flex flex-col items-center justify-center min-h-[200px]">
                <span class="mt-4 text-muted-color">Cargando configuración...</span>
            </div>
            } @else {
            <div class="flex flex-col gap-2 p-4 border surface-border border-round bg-surface-50">
                <div class="flex items-center gap-2 mb-2">
                    <i class="pi pi-clock text-primary"></i>
                    <span class="font-bold">Sucursales pendientes hoy</span>
                </div>
                <p class="text-sm text-muted-color mb-3">
                    Correos que recibirán alerta de sucursales que no han realizado su corte.
                </p>
                <p-autocomplete placeholder="Escriba el correo y presione Enter"  separator=","
                    formControlName="pending_branches_today" multiple fluid [typeahead]="false"F />
            </div>

            <div class="flex flex-col gap-2 p-4 border surface-border border-round bg-surface-50">
                <div class="flex items-center gap-2 mb-2">
                    <i class="pi pi-exclamation-triangle text-orange-500"></i>
                    <span class="font-bold">Discrepancias en cierres</span>
                </div>
                <p class="text-sm text-muted-color mb-3">
                    Correos que recibirán aviso cuando exista diferencia entre el cierre y los cortes.
                </p>
                <p-autocomplete placeholder="Escriba el correo y presione Enter" multiple fluid [typeahead]="false"
                    formControlName="closing_discrepancies" separator="," />


            </div>
            }
        </div>
    </ng-template>

    <ng-template #footer>
        <p-button label="Cancelar" icon="pi pi-times" [text]="true" (click)="hideDialog()" />
        <p-button [label]="savingData() ? 'Guardando...' : 'Guardar'" (onClick)="save()"
            [icon]="savingData() ? 'pi pi-spin pi-spinner' : 'pi pi-check'" [disabled]="savingData() || isLoading()" />
    </ng-template>

</p-dialog>
